import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import "./vendor/Product/wwdev/product"
import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';
import './externals/flickity';

import './externals/animation';

import './vendor/Shared/Header.js';
import './base/form';
import './base/smartMenu';
import './vendor/Product/OverviewFilters';

import './vendor/Product/Form';

import './sections/imageSlider'
import './sections/search_jobs';
import './sections/packets';
import './sections/partnerTabs';
import './sections/logoSlider';

//import './base/CookieBar';
import advancedEu from '@wwdev/cookiebar/eu';
import Flickity from "flickity";

if (typeof euCookiebarConfig != 'undefined' && euCookiebarConfig.active == 1) {
	let myCookieBar = new advancedEu({
		text: {
			common: euCookiebarConfig.common_text,
			cookiemodal: {
				heading: euCookiebarConfig.modal.heading,
				intro: euCookiebarConfig.modal.text,
				category: {
					necessary: {
						label: euCookiebarConfig.modal.category.necessary.label,
						label2: euCookiebarConfig.modal.category.necessary.label2,
						text: euCookiebarConfig.modal.category.necessary.text
					},
					analytics: {
						label: euCookiebarConfig.modal.category.analytics.label,
						text: euCookiebarConfig.modal.category.analytics.text
					},
					advertisement: {
						label: euCookiebarConfig.modal.category.advertisement.label,
						text: euCookiebarConfig.modal.category.advertisement.text
					},
					functionality: {
						label: euCookiebarConfig.modal.category.functionality.label,
						text: euCookiebarConfig.modal.category.functionality.text
					}
				},
				footer: {
					buttons: {
						accept: euCookiebarConfig.modal.footer.buttons.accept,
						save: euCookiebarConfig.modal.footer.buttons.save
					}
				}
			}
		},
		buttonText: {
			settings: euCookiebarConfig.buttons.settings,
			accept: euCookiebarConfig.buttons.accept
		}
	});
}
;

class TeamSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-collapse-wrapper]',
			toggle: '[data-bs-toggle="collapse"]',
			collapse: '[data-collapse-content]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		$(document).on('click', `${this.config.scope} ${this.config.toggle}`, this.onClick.bind(this));

		this.$scope.each((index, element) => {
			let $collapse = $(element).find(this.config.collapse);
			$collapse.on('shown.bs.collapse', this.onToggle.bind(this, $collapse));
			$collapse.on('hidden.bs.collapse', this.onToggle.bind(this, $collapse));
		});
	}

	onClick(event) {
		let $button = $(event.currentTarget);

		if ($button.attr('aria-expanded') == 'true') {
			$button.find('[data-more]').addClass('d-none');
			$button.find('[data-more]').removeClass('d-inline');
			$button.find('[data-less]').addClass('d-inline');
			$button.find('[data-less]').removeClass('d-none');
		} else {
			$button.find('[data-more]').removeClass('d-none');
			$button.find('[data-more]').addClass('d-inline');
			$button.find('[data-less]').removeClass('d-inline');
			$button.find('[data-less]').addClass('d-none');
		}
	}

	onToggle($collapse) {
		let $flickity = $collapse.closest('.flickity-carousel');
		let slider = Flickity.data($flickity[0]);
		slider.resize();

		setTimeout(() => {
			slider.resize();
		}, 400)
	}
}

new TeamSlider;